import { useContext, useState, useEffect } from "react";
import { AuthContext } from "./AuthContext";

export interface IProps {
    requriedLicence: ("Education" | "Single Office (Unlimited Access)" | "Multi-Office" | "Single Office (Single Access)" | "Bureau" | "Free Trial")[];
}
export default function LicenceCheck({ children, requriedLicence }: React.PropsWithChildren<IProps>) {
    const { checkLicence, userDetails } = useContext(AuthContext);
    const [passed, setPassed] = useState(false);

    useEffect(() => {
        if (requriedLicence.length == 0) {
            setPassed(true);
            return;
        }

        const isAuthorized = checkLicence(requriedLicence);
        setPassed(isAuthorized);

    }, [userDetails?.role]);

    return passed && children;
}
